import SearchField from "../SearchField/SearchField";
import ButtonCardWithImage from "../Buttons/ButtonCardWithImage/ButtonCardWithImage";
import {cryptoListScreenUrl, discoverStocksUrl, indicesListScreenUrl} from "../../Route_urls";
import Spacer from "../Spacer";
import React from "react";
import {increase, audit, magnet} from "../../static/images/images";
import {gql, useLazyQuery} from "@apollo/client";
import {useState} from "react";


const QUERY_ALL_STOCKS = gql`
    query getAllStock($first: Int, $after: String, $searchText: String, $country: String,  $sector: String) {
        allStocks (first: $first, after: $after, searchText: $searchText, country: $country, sector: $sector){
            pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
            }
            edges {
                cursor
                node {
                    profileId {
                        ticker
                        dayLow
                        dayHigh
                        currentPrice
                        changeLastDay
                        changePercentageLastDay
                        currency
                        country
                        priceChangeDateTime
                        swedishIndex {
                            fullName
                        }
                    }
                    id

                    fullName
                    slug
                    currency

                }
            }
        }}`


const UserDashboard = () => {
    const [fetchedStockList, setFetchedStockList] = useState()
    const [searchText, setSearchText] = useState('')
    const first = 10

    const handleSearchInputChange = (e) => {
        setSearchText(e.target.value)
        queryAllStocks()
    }
    

    const [queryAllStocks] = useLazyQuery(
        QUERY_ALL_STOCKS, {
            variables: {
                after: null,
                first: first,
                searchText: searchText,
            },
            fetchPolicy: 'network-only',
            onCompleted: (data) => {
                if (searchText === '') {
                    setFetchedStockList([])
                } else {
                    setFetchedStockList(data.allStocks.edges)
                }

            }
        }
    );
    return (
        <>
            <div style={{margin: '20px'}}>
                <SearchField searchText={searchText} onChange={handleSearchInputChange}
                             dropdownResults={fetchedStockList} showDropdownResults/>
            </div>
            <Spacer axis="vertical" size={20}/>
            <div className="flex flex-col space-y-4 sm:flex-row sm:justify-center sm:space-y-0 sm:space-x-4">
                <ButtonCardWithImage url={discoverStocksUrl} imageSrc={increase}
                                     title={"Discover Global Stocks"}
                                     text={"Here are the biggest stocks from major stock exchanges"}
                                     buttonText={"Discover stocks"}/>

                <ButtonCardWithImage url={indicesListScreenUrl} imageSrc={audit}
                                     title={"Discover World Indexes"}
                                     text={"Browse through our list of most influental global Indexes"}
                                     buttonText={"Discover indexes"}/>

                <ButtonCardWithImage url={cryptoListScreenUrl} imageSrc={magnet}
                                     title={"Discover World of Crypto"}
                                     text={"Browse through our list of most important crypto currencies"}
                                     buttonText={"Discover crypto currencies"}/>

            </div>
            <Spacer size={150}/>

        </>
    )
}

export default UserDashboard
